import DropdownButton from "@/components/DropdownButton";
import { STATUS } from "@/config/progress";
import { useTranslation } from "react-i18next";

interface ActionButtonProps {
  id: number;
  statusId: number;
  hasFirstEvaluationReport: boolean;
  hasSecondEvaluationReport: boolean;
  hasImprovementProposal: boolean;
}

function ActionButton({
  id,
  statusId,
  hasFirstEvaluationReport,
  hasImprovementProposal,
  hasSecondEvaluationReport,
}: ActionButtonProps) {
  const { t } = useTranslation();
  if (
    statusId < STATUS.IMPROVEMENT_PROPOSAL_COMPLETED ||
    statusId > STATUS.CERTIFICATED_ISSUED
  ) {
    return null;
  }
  return (
    <DropdownButton
      items={[
        {
          key: "first-evaluation-report",
          item: t("evaluation-report"),
          hide: !hasFirstEvaluationReport,
          onClick: async () => {
            window.open(
              `/app/assessment-results/${id}?isFirstTime=true`,
              "_blank",
            );
          },
        },
        {
          key: "improvement-proposal",
          item: t("improvement-proposal"),
          hide: !hasImprovementProposal,
          onClick: async () => {
            window.open(`/app/improvement-proposals/${id}`, "_blank");
          },
        },
        {
          key: "second-evaluation-report",
          item: t("re-assessment-report"),
          hide: !hasSecondEvaluationReport,
          onClick: async () => {
            window.open(
              `/app/assessment-results/${id}?isFirstTime=false`,
              "_blank",
            );
          },
        },
      ]}
    />
  );
}

export default ActionButton;
